/** One channel holdout's share of an audience's active members (MPN-2078). */
export interface AudienceChannelHoldout {
  channel: string;
  label: string;
  /** Active members (being shown ads) held out of this channel: a subset of total_targetable. */
  active_count: number;
}

export class AudienceDefinition {
  id!: number;
  name!: string;
  rules!: Record<string, any>;        // JSON-based rule structure
  audience_preset!: any | null;       // Linked preset object
  launch_id!: number;
  ad_group_id: number | null = null;  // AdGroup this audience drives ads/placements through (discovery key)
  total_members: number = 0;
  total_active: number = 0;
  total_targetable: number = 0;   // members being shown ads (is_serving_ads AND NOT a CPS holdout)
  total_converted: number = 0;
  // One per enabled channel holdout on the audience's population (MPN-2078). Absent on an
  // older server.
  channel_holdouts?: AudienceChannelHoldout[];
}